@if (mainLayer.cards?.length) {
    <div class="flex flex-col items-center justify-center gap-2 text-sm">
        <div class="flex flex-row bg-transparent max-w-[90vw] items-center overflow-x-auto gap-2 p-8">
            @for (cardInHand of cardsInHand; track cardInHand.id) {
                <magic-hand-item [deckCard]="cardInHand.deckCard"></magic-hand-item>
            }
        </div>
        <div class="flex flex-row gap-4 items-center justify-center">
            <div class="flex items-center justify-center">
                <button (click)="drawCard()" class="text-center w-[10ch] text-ponder-light bg-slate-50 rounded shadow-sm cursor-pointer hover:bg-ponder-link hover:bg-opacity-30">
                    <div class="p-1 rounded w-full h-full text-center">
                        Draw
                    </div>
                </button>
            </div>
            <div class="flex items-center justify-center">
                <button (click)="drawNewHand()" class="text-center w-[10ch] text-ponder-light bg-slate-50 rounded shadow-sm cursor-pointer hover:bg-ponder-link hover:bg-opacity-30">
                    <div class="p-1 rounded w-full h-full text-center">
                        New Hand
                    </div>
                </button>
            </div>
            <div class="flex items-center justify-center">
                <button (click)="sortCards()" class="text-center w-[10ch] text-ponder-light bg-slate-50 rounded shadow-sm cursor-pointer hover:bg-ponder-link hover:bg-opacity-30">
                    <div class="p-1 rounded w-full h-full text-center">
                        Sort
                    </div>
                </button>
            </div>
        </div>
    </div>
}